import { useIsAuthenticated } from "@azure/msal-react";

import { ChatThread } from "@/components/scenario/ChatThread";
import { Chevron } from "@/components/ui/Chevron";
import { signIn } from "@/lib/auth/msal";

/**
 * Landing page.
 *
 * Hero copy is action-oriented (OpenClaw cue): "what we do", not
 * "what we are". Below the fold, signed-in users see the scenario
 * capture form; signed-out users see a single CTA to sign in.
 */
export function Landing() {
  const isAuthed = useIsAuthenticated();

  return (
    <div className="mx-auto max-w-3xl space-y-10">
      <section className="space-y-4">
        <p className="font-mono text-sm uppercase tracking-widest text-muted-foreground">
          <Chevron className="mr-2" /> the pattern agent
        </p>
        <h1 className="text-4xl font-semibold tracking-tight md:text-5xl">
          Describe your integration.
          <br />
          PTRN picks the pattern and deploys it.
        </h1>
        <p className="text-lg text-muted-foreground">
          A super-agent and a catalogue of Azure integration-pattern
          experts run a competitive evaluation against your scenario,
          recommend the best fit, capture the parameters they need, and
          ship the Bicep into your subscription.
        </p>
      </section>

      {isAuthed ? (
        <ChatThread />
      ) : (
        <section className="rounded-lg border border-border/60 bg-card p-8 text-center">
          <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
            <Chevron pulse className="mr-2" /> sign in to begin
          </p>
          <h2 className="mt-3 text-xl font-semibold">
            PTRN runs against your Azure subscription
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Sign in with the Microsoft account you use for Azure. We use
            that identity to deploy the pattern you accept; nothing leaves
            your tenant.
          </p>
          <button
            type="button"
            onClick={() => {
              void signIn();
            }}
            className="mt-6 inline-flex items-center justify-center rounded-md bg-primary px-5 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            <Chevron className="mr-1.5 text-primary-foreground" />
            Sign in with Microsoft
          </button>
        </section>
      )}
    </div>
  );
}
